import { Component, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { DomSanitizer } from '@angular/platform-browser';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EmailEditorComponent } from 'angular-email-editor';
import { ToastrService } from 'ngx-toastr';
import { catchError, EMPTY, map, merge, startWith, switchMap, of as observableOf } from 'rxjs';
import { EmailTemplateService } from 'src/app/private/services/email-tempate.service';
import { UsersService } from 'src/app/private/services/users.service';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { TrackingService } from 'src/app/private/services/tracking.service';


@Component({
  selector: 'app-email-template',
  templateUrl: './email-template.component.html',
  styleUrls: ['./email-template.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class EmailTemplateComponent {


  dataSource: MatTableDataSource<any> = new MatTableDataSource();
  totalRows = 0;
  currentPage = 0;
  pageSize = 25;
  pageSizeOptions: number[] = [10, 25, 100];
  @ViewChild(MatPaginator)
  paginator!: MatPaginator;
  @ViewChild(MatSort)
  sort!: MatSort;
  searchQuery = new FormControl();
  dateQuery = new FormControl();
  btnLoading = false;
  initialLoad = true;
  processedData: any;
  processedAttachments: any[] = [];
  previewTemplateName = '';
  templateToDelete: any;
  templateEdit: any;
  isAdmin: boolean = false;
  visibleTemplates: any[] = [];
  viewMode: 'cards' | 'table' = 'cards';
  categoryFilter = 'ALL';
  statusFilter = 'ALL';
  searchText = '';
  categoryFilters = [
    { id: 'ALL', label: 'All Categories' },
    { id: 'marketing', label: 'Marketing' },
    { id: 'transactional', label: 'Transactional' },
  ];

  displayedColumns: string[] = [
    // "Client_ID",
    "Template_Name",
    "Template_Category",
    "Template_Body",
    "Status",
    "action"
  ];

  constructor(
    private toast: ToastrService,
    private api: EmailTemplateService,
    private modalService: NgbModal,
    private localStorage: LocalStorageService,
    private userApi: UsersService,
    private sanitizer: DomSanitizer,
    private tracker: TrackingService
  ) {

     this.isAdmin = this.localStorage.checkFullAccessForTableList(
      this.localStorage.getRole()
    );
  }

  ngAfterViewInit() {
    this.loadData();
  }


  loadData() {

    try {
      const sortChange = this.sort?.sortChange ?? EMPTY;
      if (this.sort) {
        this.sort.sortChange.subscribe(() => (this.paginator.pageIndex = 0));
      }
      merge(
        this.dateQuery.valueChanges,
        this.searchQuery.valueChanges,
        sortChange,
        this.paginator.page
      )
        .pipe(
          startWith({}),
          switchMap(() => {
          
            let param : any = {
              where:{
                "client_id": this.localStorage.getClientId(),
              },
              "page":  this.paginator.pageIndex * this.paginator.pageSize,
              "limit": this.paginator.pageSize,
            }

            if(!this.isAdmin) {
              param.where.user_id = this.localStorage.getUserId();
            }

            return this.api
              .getAllTemplate(param)
              .pipe(catchError(() => {
                return observableOf([]);
              }
              ));
          }),
          map((response: any) => {
            if (response === null) {
              return [];
            }
            this.totalRows = response.count;
            return response.rows;
          })
        )
        .subscribe({
          next: (data) => {
            this.initialLoad = false;
            this.dataSource = new MatTableDataSource<any>(data);
            this.refreshVisible();
          },
          error: (e) => {
            this.initialLoad = false;
            console.error(e);
          },
          complete: () => {
          },
        });
    } catch (e) {
      console.error(e);
    }
  }

  handleUpdateData(type?: string) {
    try{

      let param : any = {
        where:{
          "client_id": this.localStorage.getClientId(),
        },
        "page":  this.paginator.pageIndex * this.paginator.pageSize,
              "limit": this.paginator.pageSize,
      }

      if(!this.isAdmin) {
        param.where.user_id = this.localStorage.getUserId();
      }

      this.api.getAllTemplate(param).subscribe(
        {
          next: (response) => {
            if (response) {
              this.totalRows = response.count;
              this.dataSource = new MatTableDataSource<any>(response.rows);
              this.refreshVisible();
            }

            if (type === "delete") {
              this.toast.success("Template deleted successfully");
               this.tracker.track("Delete", "Email Template", `Deleted template: ${this.templateToDelete?.template_name}`);
            }

            if (type === "Update") {
              this.toast.success("Template updated successfully");
              this.tracker.track("Update", "Email Template", `Updated template: ${this.templateEdit?.template_name}`);
            }

            if (type === "Create") {
              this.toast.success("Template added successfully");
              this.tracker.track("Create", "Email Template", `Created new template`);
        
            }

            this.btnLoading = false

            this.modalService.dismissAll();
          },
          error: (e) => {
            console.error(e);
          },
          complete: () => {
          },
        }
      )

    }catch(e){
      console.error(e);
    }
  }


  open(content: any) {
    this.modalService.open(content, {
        size: 'xl',
        scrollable: true,
        centered: true,
        windowClass: 'my-class',
        backdrop: 'static',   // ❌ Disable close on outside click
        keyboard: false       // ❌ Disable close on ESC key (optional but recommended)
      });
  }

  handleOpenPreviewDialog(content: any,template: any) {
    this.previewTemplateName = template?.template_name || 'Template';
    this.processedData = this.sanitizer.bypassSecurityTrustHtml(template?.template_body || '');
    this.processedAttachments = Array.isArray(template?.attachments) ? template.attachments : [];
    this.modalService.open(content, {
      centered: true,
      size: 'xl',
      backdrop: 'static',
      keyboard: false,
      windowClass: 'em-preview-modal',
    });
    
    this.tracker.track(
    'Preview',
    'Email Template',
    `Previewed template: ${template.template_name}`
  );
  }
    

  handleOpenEditDialog(content: any, template: any) {
    this.templateEdit = template;
    this.modalService.open(content, { size: 'xl', scrollable: true, centered: true , windowClass: 'my-class' ,backdrop: 'static',  keyboard: false});
      this.tracker.track(
    'Edit',
    'Email Template',
    `Opened edit dialog for template: ${template.template_name}`
  );

  }

  handleDeleteEvent() {

    this.btnLoading = true;
  
    const payload = {
      template_id: this.templateToDelete.template_id
    }
  
      this.api.deleteTemplate(payload).subscribe((response:any) => {
        if (response) {
          this.handleUpdateData("delete");
        }
      },
      (error:any) => {
        this.btnLoading = false;
        this.toast.error("Something went wrong");
      });
    
    }

  refreshVisible(): void {
    const query = (this.searchText || '').trim().toLowerCase();
    const rows = this.dataSource?.data || [];
    this.visibleTemplates = rows.filter((template: any) => {
      const category = (template?.template_category || '').toLowerCase();
      const status = (template?.status || '').toLowerCase();
      if (this.categoryFilter === 'marketing' && category !== 'marketing') return false;
      if (this.categoryFilter === 'transactional' && (category === 'marketing' || !category)) return false;
      if (this.statusFilter !== 'ALL' && status !== this.statusFilter) return false;
      if (!query) return true;
      const haystack = `${template?.template_name || ''} ${category} ${this.plainPreview(template?.template_body)}`.toLowerCase();
      return haystack.includes(query);
    });
  }

  setCategory(category: string): void {
    this.categoryFilter = category;
    this.refreshVisible();
  }

  setViewMode(mode: 'cards' | 'table'): void {
    this.viewMode = mode;
  }

  isMarketing(template: any): boolean {
    return (template?.template_category || '').toLowerCase() === 'marketing';
  }

  isActive(template: any): boolean {
    return (template?.status || '').toLowerCase() === 'active';
  }

  categoryLabel(category: string): string {
    if (!category) return 'Uncategorized';
    return category.replace(/-/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase());
  }

  plainPreview(html: string): string {
    if (!html) return '';
    return html
      .replace(/<style[\s\S]*?<\/style>/gi, ' ')
      .replace(/<script[\s\S]*?<\/script>/gi, ' ')
      .replace(/<[^>]+>/g, ' ')
      .replace(/&nbsp;/gi, ' ')
      .replace(/&amp;/gi, '&')
      .replace(/\s+/g, ' ')
      .trim();
  }

  get templateStats() {
    const rows = this.dataSource?.data || [];
    const active = rows.filter((row: any) => this.isActive(row)).length;
    const marketing = rows.filter((row: any) => this.isMarketing(row)).length;
    return {
      total: this.totalRows || rows.length,
      active,
      marketing,
      transactional: rows.filter((row: any) => row?.template_category && !this.isMarketing(row)).length,
    };
  }

  handleOpenDeleteTemplateDialog(content: any, element: any) {
    this.modalService
      .open(content, { size: 'md', centered: true  ,backdrop: 'static',  keyboard: false})

    this.templateToDelete = element;
     this.tracker.track(
    'Open Delete Modal',
    'Email Template',
    `Opened delete dialog for template: ${element.template_name}`
  );
  }
  

}